import { QueryClientProvider } from '@tanstack/react-query';
import { useEffect } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

import { Toaster } from '@terra/ui';

import { VendorShell } from './components/VendorShell';
import { queryClient } from './lib/queryClient';
import { AccountPage } from './pages/AccountPage';
import { BulkUploadPage } from './pages/BulkUploadPage';
import { CreateProductPage } from './pages/CreateProductPage';
import { CustomerSupportPage } from './pages/CustomerSupportPage';
import { ForgotPasswordPage } from './pages/ForgotPasswordPage';
import { LoginPage } from './pages/LoginPage';
import { NoteListPage, AddNotePage } from './pages/notes';
import { OffersPage } from './pages/OffersPage';
import { InvoicePage } from './pages/orderFulfilment';
import {
  AnalyticsPage,
  InventoryPage,
  NotFoundPage,
  OnboardingPage,
  OrdersPage,
  OrderDetailPage,
  OverviewPage,
  ProductsPage,
  ReturnsPage,
  SponsoredPage,
  SubscriptionPage,
  SupportPage,
  WalletPage,
} from './pages/pages';
import { ProductSupportPage } from './pages/ProductSupportPage';
import { RegisterPage } from './pages/RegisterPage';
import { useAuthStore } from './stores/authStore';

export function App() {
  const bootstrap = useAuthStore((s) => s.bootstrap);
  useEffect(() => {
    void bootstrap();
  }, [bootstrap]);

  return (
    <QueryClientProvider client={queryClient}>
      <Toaster position="top-center" />
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route element={<VendorShell />}>
            <Route index element={<OverviewPage />} />
            <Route path="onboarding" element={<OnboardingPage />} />
            <Route path="account" element={<AccountPage />} />
            <Route path="products" element={<ProductsPage />} />
            <Route path="products/new" element={<CreateProductPage />} />
            <Route path="products/bulk" element={<BulkUploadPage />} />
            {/* Param is the product slug (api.products.getBySlug); the
                navigation in pages.tsx passes `p.slug` here. */}
            <Route path="products/:slug/edit" element={<CreateProductPage />} />
            <Route path="inventory" element={<InventoryPage />} />
            <Route path="orders" element={<OrdersPage />} />
            <Route path="orders/:orderId" element={<OrderDetailPage />} />
            <Route path="orders/:orderId/invoice" element={<InvoicePage />} />
            <Route path="returns" element={<ReturnsPage />} />
            <Route path="wallet" element={<WalletPage />} />
            <Route path="subscription" element={<SubscriptionPage />} />
            <Route path="offers" element={<OffersPage />} />
            <Route path="sponsored" element={<SponsoredPage />} />
            <Route path="analytics" element={<AnalyticsPage />} />
            <Route path="support" element={<SupportPage />} />
            <Route path="customer-support" element={<CustomerSupportPage />} />
            <Route path="customer-support/:ticketId" element={<CustomerSupportPage />} />
            <Route path="product-support" element={<ProductSupportPage />} />
            <Route path="notes" element={<NoteListPage />} />
            <Route path="notes/new" element={<AddNotePage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </QueryClientProvider>
  );
}
